import React, { createContext, useState, useEffect } from "react";
import { getAllFoods } from "./FoodAPI";
import * as Storage from "ts-storage";

export const FoodContext = createContext<any>([]);

const FoodProvider: React.FC<{ children: any }> = ({ children }) => {
  const [food, setFood] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCart, setShowCart] = useState<boolean>(false);
  const [cart, setCart] = useState<any>([]);

  useEffect(() => {
    setLoading(true);
    getAllFoods().then((data: any) => {
      setFood(data);
      setLoading(false);
    });

    // get cart from localstorage

    let storageItem = Storage.get("foodcart", "").value;
    if (storageItem === "") {
      Storage.set("foodcart", JSON.stringify([]));
      setCart([]);
    } else {
      let cartFromLS = JSON.parse(Storage.get("foodcart", "").value);

      if (cartFromLS.length !== 0) {
        setCart(cartFromLS);
      }
    }
  }, []);

  return (
    <FoodContext.Provider
      value={[
        food,
        setFood,
        loading,
        setLoading,
        showCart,
        setShowCart,
        cart,
        setCart,
      ]}
    >
      {children}
    </FoodContext.Provider>
  );
};

export default FoodProvider;
